import React from 'react';
import { Calendar, MapPin, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const WorldBookRecords = () => {
  const records = [
    {
      title: "150 HOURS CONTINUOUS PRESENTATION",
      date: "03 TO 09TH SEPTEMBER 2020",
      place: "Chennai",
      description: "For organizing the longest international conferences following the duration of 150 hours continuously from 03 to 09 September 2020. ESN publications from Chennai has set its record for organizing the longest international conferences following the duration of 150 hours continuously from 03 to 09 September 2020 at hotel Turyaa, OMR Road Perungudi, Chennai (Tamil Nadu) India. World Book of Records, London appreciates their passion for reading and writing to the extent of making it a mission and includes them in its India edition-2020. The publication house is dedicated to publish just academic books and has published more than 100 books so far.",
      images: [ "/records/world-book/150 hrs.png"],
      link: "https://worldbookofrecords.uk/records/record_detail/esn-publications-of-madurai--tamil-nadu--india-gets-included-by-world-book-of-records-----london779"
    },
    {
      title: "THICKEST BOOK OF THE WORLD",
      date: "30TH January 2021",
      place: "Chennai",
      description: "ESN Publications published the Thickest Book of the World containing 1210 research papers and 11, 796 pages under the supervision of its Founder Chairman Mr. J. Banuchandar. The publication published the thickest book ever and set a world record on 30th Jan, 2021. The book contains 1210 research papers' compilation in 11, 796 pages in total. The title of the book is 'Latest Innovation for Future Education'. World Book of Records, UK cherishes the faith and vision behind this initiative and includes it in its India edition.",
      images: ["/records/world-book/thickest book.png"],
      link: "https://worldbookofrecords.uk/records/record_detail/esn-publications-from-virudhunagar--tamil-nadu-gets-included-by-world-book-of-records---london507"
    },
    {
      title: "1111 POEMS 1111 POETS",
      date: "15TH AUGUST 2022",
      place: "Chennai",
      description: "For publishing 1111 poems 1111 poets as a single book with ISBN 978-93-90781-11-9 in multiple languages on 17 November 2021. ESN publications from Chennai has set its second record by publishing 1111 poems 1111 poets as a single book with ISBN 978-93-90781-11-9 in multiple languages on 17 November 2021. World Book of Records, London appreciates their passion for reading and writing to the extent of making it a mission and includes them in its India edition-2021.",
      images: ["/records/world-book/_DSC2595.jpg"],
      link: "https://worldbookofrecords.uk/records/record_detail/esn-publications-of-madurai--tamil-nadu--india-gets-included-by-world-book-of-records---london778"
    }
  ];

  return (
    <div style={{ backgroundColor: 'var(--bg-page)', minHeight: '100vh', padding: '80px 0' }}>
      <div className="container-custom">
        <Link to="/records" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: 'var(--brand-primary)', textDecoration: 'none', marginBottom: '30px', fontWeight: '600' }}>
          <ArrowLeft size={20} />
          <span>Back to Records</span>
        </Link>
        <h1 className="heading-1" style={{ marginBottom: '50px', textAlign: 'center' }}>WORLD BOOK OF RECORDS</h1>
        
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <div style={{ display: 'inline-block', backgroundColor: '#ffd700', color: '#000', padding: '8px 20px', borderRadius: '25px', fontSize: '0.9rem', fontWeight: 'bold', marginBottom: '20px' }}>
              🏆 WORLD BOOK OF RECORDS
            </div>
            
          </div>
          {records.map((record, index) => (
            <div key={index} style={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-medium)', borderRadius: '16px', padding: '50px', marginBottom: '50px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
              <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <div style={{ display: 'inline-block', backgroundColor: 'var(--brand-primary)', color: 'white', padding: '8px 20px', borderRadius: '25px', fontSize: '0.9rem', fontWeight: 'bold', marginBottom: '20px' }}>
                  WORLD BOOK OF RECORDS
                </div>
                <h2 className="heading-2" style={{ color: 'var(--brand-primary)', fontSize: '1.8rem', marginBottom: '10px' }}>{record.title}</h2>
              </div>
              
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '40px' }}>
                {record.images.map((image, imgIndex) => (
                  <div key={imgIndex} style={{ maxWidth: '600px', width: '100%' }}>
                    <img src={image} alt={`${record.title} ${imgIndex + 1}`} style={{ width: '100%', height: '400px', objectFit: 'contain', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.15)', border: '2px solid var(--border-medium)' }} />
                  </div>
                ))}
              </div>
              
              <div style={{ display: 'flex', justifyContent: 'center', gap: '50px', marginBottom: '40px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'var(--bg-page)', padding: '12px 20px', borderRadius: '25px' }}>
                  <Calendar size={22} color="var(--brand-primary)" />
                  <span style={{ fontWeight: '600', fontSize: '1rem' }}>{record.date}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'var(--bg-page)', padding: '12px 20px', borderRadius: '25px' }}>
                  <MapPin size={22} color="var(--brand-primary)" />
                  <span style={{ fontWeight: '600', fontSize: '1rem' }}>{record.place}</span>
                </div>
              </div>
              
              <div style={{ backgroundColor: 'var(--bg-page)', padding: '30px', borderRadius: '12px', border: '1px solid var(--border-medium)' }}>
                <p className="body-medium" style={{ lineHeight: '1.8', textAlign: 'justify', fontSize: '1.1rem', margin: 0 }}>
                  {record.description}
                </p>
                {record.link && (
                  <div style={{ marginTop: '24px', textAlign: 'center' }}>
                    <a
                      href={record.link}
                      target="_blank"
                      rel="noreferrer noopener"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '14px 28px',
                        borderRadius: '9999px',
                        backgroundColor: '#ffb703',
                        color: '#102a43',
                        fontWeight: '700',
                        textDecoration: 'none',
                        boxShadow: '0 12px 30px rgba(255, 181, 3, 0.2)',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                      }}
                      onMouseEnter={(event) => { event.currentTarget.style.transform = 'translateY(-2px)'; event.currentTarget.style.boxShadow = '0 18px 40px rgba(255, 181, 3, 0.28)'; }}
                      onMouseLeave={(event) => { event.currentTarget.style.transform = 'translateY(0)'; event.currentTarget.style.boxShadow = '0 12px 30px rgba(255, 181, 3, 0.2)'; }}
                    >
                      View Official Record
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorldBookRecords;